import sliceCreator from '../../index.jsx';
import {GET_DAILY_TASKS} from '../../../constants/index.jsx';
const _getAllDailyTasksAction = sliceCreator('GET_ALL_DAILY_TASKS', GET_DAILY_TASKS, 'get');

const { asyncAction: getAllDailyTasksAction, reducer, clearData: clearGetAllDailyTasksAction } = _getAllDailyTasksAction;

export default reducer;

export {
    getAllDailyTasksAction,
    clearGetAllDailyTasksAction
}